import hero from './hero';
import carousel from './logo-carousel';
import header from './header';
import './current-openings';
import './ajaxScripts';
import './truestoryAjax';
import './newsletterPopup';
import './truestoryForm';
import './tabs';
import './investors';
import './contactForm';
import './peopleIndex';
import './careerForm';
import './careerFormIndex';
import './videoPopup';
import setofferingheight from './offering-content';
import './jumpToTransitions';
import './transition';
import './postfilter';
import './feedPress';
import './calculate';
import './calculator-slider';
import './pain-point-form';
import './awards';
import './popup-model';
import './landing-menu';
import './cookie-setup';
import './popup-model-subscribe';
import './popup-model-stanza';
import './current-chennai';
import './ats-current-openings';
import './ats-current-openings/ats-cdpage';
import './thumb-slider';

hero();
carousel();
header();
setofferingheight();
